import axios from "axios";
import { API } from "../../utils/index";
const instance = axios.create();

// Save challenge
export const getLogos = async () => {
  return instance.get(`${API}/logo`);
};
